<template>
  <div>
    <H1>ERROR PAGE !!!!!!</H1>
  </div>
</template>

<script>
export default {
  name: "ErrorPage"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ErrorPage.vue